const DefaultWidgetBody = ({ widgetData }) => {
  const subLabels = widgetData?.sublabels;
  const widgetValues = widgetData?.values;
  const record = widgetData?.RECORD;
  const record2 = widgetData?.RECORD2;
  const metricEntries = subLabels && widgetValues && widgetValues.length > 0
    ? subLabels.map((label, index) => {
      const valueEntry = Object.entries(widgetValues[0] || {})[index];

      return {
        key: valueEntry?.[0] || `${label.SUBHEADER}-${index}`,
        label: label.SUBHEADER,
        value: valueEntry?.[1] || '',
      };
    })
    : [];

  return (
    <div className="widgetMid">
      {metricEntries.length === 0 && (
        <div className="additionalData">
          {subLabels && subLabels.length > 0 ? (
            <div className="widgetContainer2">
              {subLabels.map((label, index) => (
                <div className="widgetMetricPair" key={`${label.SUBHEADER}-${index}`}>
                  <div className="widgetSubheader">
                    {label.SUBHEADER}
                  </div>
                  {index !== subLabels.length - 1 && (
                    <div className="columnDivider"></div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div></div>
          )}
        </div>
      )}
      <div className="widgetValues">
        {metricEntries.length > 0 ? (
          <div className="widgetMetricGrid">
            {metricEntries.map((entry) => (
              <div className="widgetMetricCell" key={entry.key}>
                <div className="widgetMetricLabel">{entry.label}</div>
                <div className="widgetMetricValue">{entry.value}</div>
              </div>
            ))}
          </div>
        ) : widgetValues && widgetValues.length > 0 ? (
          <div className="widgetContainer2">
            {Object.entries(widgetValues[0]).map(([key, value], index) => (
              <div className="widgetMetricPair" key={key}>
                <div className="widgetSubheader">
                  {value}
                </div>
                {index !== Object.entries(widgetValues[0]).length - 1 && (
                  <div className="columnDivider"></div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="widgetSingleValue">
            {record && (
              <div className="recordDisplay">
                {record}
              </div>
            )}
            <div className="widgetRecord2">
              {record2 && (
                <div className="record2Value">
                  {record2}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DefaultWidgetBody;
